var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form-control', {
    attrs: {
      "field": _vm.field
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [(_vm.items !== undefined && !_vm.multiple) ? _c('v-autosuggest', {
          attrs: {
            "value": api.getValue(),
            "select": _vm.select,
            "items": _vm.items,
            "name": _vm.field,
            "readonly": api.isReadonly() || _vm.readonly,
            "caption": _vm.caption,
            "label": _vm.labelWithRequired,
            "error": api.getTouched() ? api.getError() : undefined,
            "placeholder": _vm.placeholder,
            "type": _vm.type,
            "getItemValue": _vm.getItemValue,
            "getItemId": _vm.getItemId,
            "getItemCaption": _vm.getItemCaption,
            "maxlength": _vm.maxlength,
            "multiple": _vm.multiple
          },
          on: {
            "input": function($event) {
              api.setValue($event);
              _vm.$emit('input', $event)
            },
            "blur": api.setTouched
          }
        }) : _vm._e(), _vm._v(" "), (_vm.items !== undefined && _vm.multiple) ? _c('v-input-multiple', {
          attrs: {
            "value": api.getValue(),
            "label": _vm.labelWithRequired,
            "placeholder": _vm.placeholder,
            "caption": _vm.caption,
            "error": api.getTouched() ? api.getError() : undefined,
            "name": _vm.field,
            "items": _vm.items,
            "maxlength": _vm.maxlength,
            "maxSelectItems": _vm.maxSelectItems,
            "altItem": _vm.altItem
          },
          on: {
            "input": function($event) {
              api.setValue($event);
              _vm.$emit('input', $event)
            },
            "blur": api.setTouched
          }
        }) : _vm._e(), _vm._v(" "), (_vm.items === undefined && !_vm.multiple) ? _c('v-input-text', {
          attrs: {
            "type": _vm.type,
            "value": api.getValue(),
            "name": _vm.field,
            "autocomplete": _vm.autocomplete,
            "readonly": api.isReadonly() || _vm.readonly,
            "disabled": _vm.disabled,
            "multiline": _vm.multiline,
            "mask": _vm.mask,
            "maxlength": _vm.maxlength,
            "caption": _vm.caption,
            "label": _vm.labelWithRequired,
            "error": api.getTouched() ? api.getError() : undefined,
            "placeholder": _vm.placeholder
          },
          on: {
            "input": function($event) {
              api.setValue($event);
              _vm.$emit('input', $event)
            },
            "blur": api.setTouched
          },
          scopedSlots: _vm._u([{
            key: "error",
            fn: function(props) {
              return [_vm._t("error", [_vm._v(_vm._s(props.error))])]
            }
          }, {
            key: "caption",
            fn: function(props) {
              return [_vm._t("caption", [_vm._v(_vm._s(props.caption))])]
            }
          }])
        }) : _vm._e()]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b42d5d0a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/Form/FormInput.vue
// module id = 690
// module chunks = 0